import { Component, OnInit } from '@angular/core';
import {ScreenManagerService} from "@mpt-fo/common/core/services/screen-manager.service";
import {
	BtnType,
	IconType,
	IdentityProvider,
	ModalType,
	SmileIdImage,
	SmileIdPayload,
	SmileIDVerificationType
} from "@mpt-fo/common/kamona/model/kamonal-model";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {LoginTypeRequest} from "@app/channels/auth/login/model/forget-passcode";
import {PasswordType, UserNameType} from "@mpt-fo/common/shared/models/utility.model";
import {StringHelper} from "@mpt-fo/common/core/helpers/strings.helper";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {DeviceHelperService} from "@mpt-fo/common/core/services/device-helper.service";
import {
	KamonaProgressModalComponent
} from "@mpt-fo/common/kamona/components/kamona-progress-modal/kamona-progress-modal.component";
import {ModalOptionsConfig, ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import {HIDE_ANT_MODAL_CLASS} from "@mpt-fo/common/shared/constants";
import {NzModalRef} from "ng-zorro-antd/modal";
import {LivelinessService} from "@mpt-fo/common/core/services/liveliness.service";
import { ClusterManagerManagementService } from '@mpt-fo/common/core/services/cluster-manager-management/cluster-manager-management.service';

@Component({
  selector: 'app-user-device-registration',
  templateUrl: './user-device-registration.component.html',
  styleUrls: ['./user-device-registration.component.scss']
})
export class UserDeviceRegistrationComponent implements OnInit {
  mobile: boolean;
  ussdCode: string;
  submitting: boolean;
  livelinessRequired: boolean;
  flowId: string;
  reference: string;
  provider: IdentityProvider;
  processVerification: boolean;
  idVerificationUrl: string;
  verificationPayload: any;
  responseData: any;
  runningModal: NzModalRef;
  readonly ModalType = ModalType;
  showSuccessModal: boolean;
  isModal: boolean;
  modalDescription: string;
  modalTitle: string;
  iconType;
  btnText: string;
  btnType;
  phoneNumber: string;
  IconType = IconType
  BtnType = BtnType;
  readonly SMILE_ID_VERIFICATION_URL = '/api/v1/settings/device-registration'
  readonly submittingDescription = 'Registering Device ...';
  readonly submittingLiveliness  = 'Submitting liveliness ...';
  maskPhoneNumber: string;
  description: string;
  constructor(
	  private screenManager: ScreenManagerService,
	  private profile: ProfileSetupService,
	  private auth: AuthenticationService,
	  private loginHelper: LoginHelperService,
	  private deviceHelper: DeviceHelperService,
	  private modalService: ModalService,
	  private livelinessService: LivelinessService,
	  private clusterManagerService: ClusterManagerManagementService,
	) { }

  ngOnInit(): void {
	  this.mobile = this.screenManager.isMobile();
	  this.screenManager.isMobile$.subscribe((mobile: boolean) => {
		  this.mobile = mobile;
	  })
  }

  initialize(){
	  const res = this.profile.getSignInResponse();
	  this.setParameters(res);
	  this.livelinessRequired = !StringHelper.isNullOrEmptyOrUndefined(this.provider);
	  this.livelinessRequired ? this.setLivelinessParameter(res) : this.setOTPParameters(res);
  }

  setParameters(res: any){
	  this.phoneNumber = res?.username;
	  this.provider = res?.provider;
	  this.maskPhoneNumber = res?.maskedPhoneNumber;
  }

  setOTPParameters(res: any){
	  this.ussdCode = res?.ussdCode;
	  this.setOTPDescription();
  }

  setLivelinessParameter(res: any){
	  this.reference = res?.reference;
	  this.flowId = res?.flowId;
  }

  setOTPDescription(){}

  openPrivacy(){

  }
  openTermsAndConditions(){

  }

  goToLogin(){
	  this.profile.routeToLogin();
  }

  handleOtpResponse($event){
	 this.openInProgressModal();
	 const payload = this.buildOTPPayload($event);
	 this.auth.activateDeviceOnLogin(payload)
	.then(res => {
			this.handleResponse(res);
		 })
	.catch(error => { this.handleFailedResponse(error)});
  }

  handleResponse(res){
	  this.closeProgressModal();
	  this.responseData = res;
	  if(this.loginHelper.isNewStaffLogin() && this.responseData.businesses){
		this.loginHelper.setStaffBusinesses(this.responseData.businesses);
	}
	  this.setSuccessModal(true);
  }

  setSuccessModal(isModal: boolean){
	  this.showSuccessModal = isModal;
  }

  closeProgressModal(){
	  this.closeModal();
  }

  getDeviceInformation(){
	  return this.deviceHelper.getDeviceInformation();
  }

  handleFailedResponse(error){
	  this.closeProgressModal();
	  const description = StringHelper.getErrorMessageHttpErrorResponse(error);
	  this.profile.handleErrorModal({description});
  }

  buildOTPPayload($event){
	 const payload = this.buildPayload();
	 this.updatePayloadWithDeviceInformation(payload);
	 return {...payload, ...$event};
  }

  updatePayloadWithDeviceInformation(payload){
	  const deviceInformation = this.getDeviceInformation();
	  payload.deviceUniqueIdentifier = deviceInformation?.deviceUniqueIdentifier;
	  payload.channel = 'WEB';
  }

  openInProgressModal() {
		const description = this.submittingDescription;
		const config = this.createConfig(description);
		this.runningModal = this.modalService.createModal(KamonaProgressModalComponent, config);
	}

  openLivelinessInProgressModal() {
		const description = this.submittingLiveliness;
		const config = this.createConfig(description);
		this.runningModal = this.modalService.createModal(KamonaProgressModalComponent, config);
  }
  createConfig(description) {
		const config = new ModalOptionsConfig();
		config.nzMaskClosable = false;
		config.nzComponentParams.data = {description};
		config.className = HIDE_ANT_MODAL_CLASS;
		return config;
	}

  buildIDPayload($event: string){
	const payload = this.buildPayload();
	this.updatePayloadWithDeviceInformation(payload);
	return {...payload, reference:$event}
 }

  buildPayload(){
	 const res = this.profile.getSignInResponse();
	  const params: { businessId?: string, refreshToken?: string } = {};
	  if (this.loginHelper.isNewStaffLogin() && this.loginHelper.staffUserTokenData() && this.loginHelper.staffUserTokenData().businesses?.length > 0) {
		  params.businessId = this.loginHelper.staffUserTokenData().businesses[0].businessId;
		  params.refreshToken = this.loginHelper.staffUserTokenData().tokenData?.refresh_token;
	  }
	  if (this.clusterManagerService.isNewClusterManagerLogin()) {
		params.refreshToken = this.clusterManagerService.tokenDataDeviceResponse.tokenData?.refresh_token;
	  }
	 return {
		  activationToken: res?.identifier,
		  identifier: res?.identifier,
		  loginType: res?.loginType,
		  username: res?.username,
		  password: res?.password,
		  ...params
	  }
  }

  restart(){

  }

  handleFinishedMetaMapVerification(){
	  this.closeProgressModal();
	  const config = this.profile.getConfig();
	  this.idVerificationUrl = `${config.MONIEPOINT_USER_URL}${this.SMILE_ID_VERIFICATION_URL}/${this.reference}/status`;
	  this.setVerificationPayload();
	  this.processVerification = true;
  }

	buildSmileIDJobPayload($event: SmileIdImage []): SmileIdPayload{
		return {
			reference: this.reference,
			images: $event,
			verificationType: SmileIDVerificationType.LIVELINESS
		}
	}

  submitSmileIDJob($event){
	  this.openLivelinessInProgressModal();
	  const payload = this.buildSmileIDJobPayload($event);
	  this.livelinessService.submitSmileIDJob(payload)
		  .then(() => {
			  this.handleSmileIDJobResponse();
		  })
		  .catch(error => {
			  this.handleSmileIDJobFailure(error);
		  })
  }

  handleSmileIDJobResponse(){
	  this.closeProgressModal();
	  const config = this.profile.getConfig();
	  this.idVerificationUrl = `${config.MONIEPOINT_USER_URL}${this.SMILE_ID_VERIFICATION_URL}/${this.reference}/status`;
	  this.setVerificationPayload();
	  this.processVerification = true;
  }

  setVerificationPayload(){
	  const res = this.profile.getSignInResponse();
	  const username = res?.username;
	  this.verificationPayload = {username}
  }

  handleSmileIDJobFailure(error){
	  this.closeProgressModal();
	  const description = StringHelper.getErrorMessageHttpErrorResponse(error);
	  this.profile.handleErrorModal({description});
  }

  handleVerifiedIdentity($event){
	  this.processVerification = false;
	  this.openInProgressModal();
	  const payload = this.buildIDPayload($event?.reference);
	  this.auth.activateDeviceOnLogin(payload)
		  .then(res => {
			  this.handleResponse(res);
		  })
		  .catch(error => {this.handleFailedResponse(error)});
  }
	handleFailedIdentity({message}){
		this.processVerification = false;
		this.setFailedLivelinessMessageParameter(message);
	}

	setFailedLivelinessMessageParameter(description: string){
		this.modalTitle= 'Identity Not Verified';
		this.iconType = IconType.ERROR;
		this.btnType = BtnType.PRIMARY;
		this.btnText = 'Try again'
		this.modalDescription = description ?? 'We have not been able to verify your identity';
		this.setModal(true);
	}

  closeSuccessModal(){
	this.setSuccessModal(false);
  }

  closeModal(){
	  if(this.runningModal){
		  this.runningModal.destroy();
	  }
  }

  setModal(isModal: boolean){
	  this.isModal = isModal;
  }

  goToDashboard(){
	 this.loginHelper.processSessionUser(this.responseData, this.getDeviceInformation())
		 .finally(() => {this.closeSuccessModal()})
  }

}
